module.exports = __webpack_public_path__ + "static/media/Sanad_logo1.1aab2cf5.png";